import {
  SlFormatBytes
} from "./chunk.VDJ6QVNC.js";

// src/components/format-bytes/format-bytes.ts
var format_bytes_default = SlFormatBytes;
SlFormatBytes.define("sl-format-bytes");

export {
  format_bytes_default
};
